import { render, staticRenderFns } from "./Tipoelettrico.vue?vue&type=template&id=d17f13cc&scoped=true&"
import script from "./Tipoelettrico.vue?vue&type=script&lang=js&"
export * from "./Tipoelettrico.vue?vue&type=script&lang=js&"
import style0 from "./Tipoelettrico.vue?vue&type=style&index=0&id=d17f13cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d17f13cc",
  null
  
)

export default component.exports